import { pxToRem } from '@modernhealth/vital-components';
import React, { FC } from 'react';
import styled from '@emotion/styled';
import { colors } from '@modernhealth/vital-foundation';
import moment from 'moment';
import { Conversation, Message } from '@modernhealth/messaging-kit';
import { useTranslation } from 'react-i18next';

export interface ProviderResponseInfoProps {
    messages: readonly Message[];
    conversation: Conversation | undefined;
}

export const ProviderResponseInfo: FC<ProviderResponseInfoProps> = ({ messages, conversation }) => {
    const { t } = useTranslation();
    if (messages.length < 1) {
        return null;
    }
    const timeDiff = moment.duration(moment().diff(moment(messages[0].sentAt)));
    const fromMember = messages[0].senderUuid === conversation?.member?.uuid;
    const fromMemberAndCoachRead = fromMember && !!messages[0].readAt;
    const showInlineMessage = fromMember && timeDiff.asHours() > 1 && !fromMemberAndCoachRead;

    if (!showInlineMessage) {
        return null;
    }

    return (
        <StyledInfoText>
            {t('messaging:conversation.list.footer.response.time', {
                name: conversation?.coach?.firstName,
            })}
        </StyledInfoText>
    );
};

const StyledInfoText = styled.p`
    padding: ${pxToRem(10)};
    text-align: center;
    background-color: ${colors.gray05};
    border-radius: ${pxToRem(5)};
    margin: ${pxToRem(0, 0, 15, 0)};
    font-size: ${pxToRem(12)};
`;
